import { config } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
export const sanitizeHTML = html => {
  return sanitize(html, config.HTML);
};